import React, { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { Copy } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function AdminPasswordResets() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/password-resets").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  const copyLink = (token) => {
    const link = `${window.location.origin}/reset-password?token=${token}`;
    navigator.clipboard.writeText(link);
    toast.success("Reset link copied");
  };

  const active = items.filter((i) => !i.used && i.expires_at > new Date().toISOString());
  const spent = items.filter((i) => i.used || i.expires_at <= new Date().toISOString());

  return (
    <div className="p-8 lg:p-12" data-testid="admin-password-resets">
      <div className="mb-8">
        <div className="overline text-[color:var(--vt-orange)] mb-2">/ SECURITY</div>
        <h1 className="font-display font-black text-4xl tracking-tighter">Password Reset Requests</h1>
        <p className="text-neutral-500 text-sm mt-1">Hand-deliver these links until an email service is connected.</p>
      </div>

      <h2 className="font-display font-bold text-xl mb-3">Active ({active.length})</h2>
      <div className="bg-white border border-neutral-200 mb-8">
        {loading ? <div className="p-8 text-center text-neutral-500">Loading...</div> :
         active.length === 0 ? <div className="p-8 text-center text-neutral-500">No active reset requests.</div> :
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 border-b border-neutral-200">
            <tr>
              <th className="text-left p-3 overline text-neutral-600">Email</th>
              <th className="text-left p-3 overline text-neutral-600">Requested</th>
              <th className="text-left p-3 overline text-neutral-600">Expires</th>
              <th className="text-right p-3 overline text-neutral-600">Action</th>
            </tr>
          </thead>
          <tbody>
            {active.map((it) => (
              <tr key={it.id} className="border-b border-neutral-100">
                <td className="p-3 font-bold">{it.email}</td>
                <td className="p-3 text-xs">{new Date(it.created_at).toLocaleString()}</td>
                <td className="p-3 text-xs">{new Date(it.expires_at).toLocaleString()}</td>
                <td className="p-3 text-right">
                  <button onClick={() => copyLink(it.token)} className="vt-btn-orange text-xs" data-testid={`copy-${it.id}`}>
                    <Copy size={14} /> Copy Reset Link
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>}
      </div>

      <h2 className="font-display font-bold text-xl mb-3 text-neutral-500">Expired / Used ({spent.length})</h2>
      <div className="bg-white border border-neutral-200">
        {spent.length === 0 ? <div className="p-8 text-center text-neutral-500 text-sm">None yet.</div> :
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 border-b border-neutral-200">
            <tr>
              <th className="text-left p-3 overline text-neutral-600">Email</th>
              <th className="text-left p-3 overline text-neutral-600">Requested</th>
              <th className="text-left p-3 overline text-neutral-600">State</th>
            </tr>
          </thead>
          <tbody>
            {spent.map((it) => (
              <tr key={it.id} className="border-b border-neutral-100">
                <td className="p-3 text-neutral-500">{it.email}</td>
                <td className="p-3 text-xs text-neutral-500">{new Date(it.created_at).toLocaleString()}</td>
                <td className="p-3 text-xs">{it.used ? "USED" : "EXPIRED"}</td>
              </tr>
            ))}
          </tbody>
        </table>}
      </div>
    </div>
  );
}
